export const FACEBOOK_AUTH_REDIRECT_URL = 'https://www.facebook.com/v17.0/dialog/oauth?response_type=token&client_id=${appId}&redirect_uri=${window.location.origin}${window.location.pathname}&state=facebookredirect';

export const AUTH_KEYS = {
    SESSION_TOKEN: 'session-token',
} as const;

export const FACEBOOK_HASH = 'access_token';

export const APPLE_QUERY_PARAM = 'apple';
export const APPLE_HASH_TOKEN = 'id_token';
export const OTP_PROOFKEY = 'proofKey';
export const OTP_TOKEN = 'token';
export enum AuthMethods {
    FACEBOOK = 'facebook',
    GOOGLE = 'google',
    APPLE = 'apple',
    USERNAME = 'userPassword',
    TOKEN = 'userToken',
    OTP = 'otp',
    DEEP_LINK = 'deepLink',
    PORTAL_REDIRECT = 'portal-redirect',
    EXTERNAL = 'external',
    RECONNECT = 'reconnect',
    STORE_IMPERSONATION = 'store-impersonation',
}

export enum LoginResult {
    SUCCESS = 'success',
    FAILED = 'failed',
}

export const DEFAULT_LOGIN_SOURCE = 'browser app';